import { ResultOf } from 'gql.tada';
import { weblinkFragment } from '../../../graphql/fragments/weblinkFragment';
import { graphql } from '../../../graphql/graphql';

export const propertyPageCtaToggleFragment = graphql(
  `
    fragment PropertyPage_CtaToggle on PropertyPage_CtaToggle {
      __typename
      activeItemIndex
      items {
        ...WebLink
      }
    }
  `,
  [weblinkFragment],
);

export type PropertyPageCtaToggle = ResultOf<typeof propertyPageCtaToggleFragment>;
